const isDev = () => process.env.NODE_ENV === 'development';

const BASE_URL = isDev()
    ? 'http://localhost:3000'
    : 'https://intranet.centroplast.ind.br/';

export default {
    BASE_URL,
    isDev,
};